import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import NavBar from 'Components/Navbar';
import withStyles from '@material-ui/core/styles/withStyles';
import Footer from 'Components/Footer';
import Container from 'Components/Container';
import Modal from 'Components/Modal';
import clsx from 'clsx';
import { useEffect } from 'react';

const pageStyles = theme => ({
  page: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  wrapper: {
    display: 'flex',
    backgroundColor: '#fff',
    flexDirection: 'column',
    minHeight: '200px',
    flex: '1',
    paddingBottom: '50px',
  },
  bottomSection: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
});

function Page({
  classes,
  children,
  hasContainer = true,
  hasNav = true,
  wrapperStyles,
  pageStyles,
  isContainerPadded = true,
  NavBarComponent = NavBar,
  FooterComponent = Footer,
}) {
  const hash = window.location.hash;
  useEffect(() => {
    const element = document.getElementById(hash.substring(1));
    if (element) {
      setTimeout(() => element.scrollIntoView(true), 10);
    }
  }, [hash]);

  function renderChildren() {
    if (hasContainer) {
      return <Container hasInnerPadding={isContainerPadded}>{children}</Container>;
    }

    return children;
  }

  return (
    <div className={clsx(classes.page, pageStyles)}>
      <CssBaseline />
      {hasNav === true && (
        <>
          <Modal />
          <NavBarComponent />
        </>
      )}

      <div className={classes.bottomSection}>
        <div className={clsx(classes.wrapper, wrapperStyles)}>{renderChildren()}</div>
        <FooterComponent />
      </div>
    </div>
  );
}

export default withStyles(pageStyles)(Page);
